export const BASE_COLUMN_GROUPS = {
  direct_marketing: {
    label: "Vermarktungserlös tatsächliche Einspeisung",
    children: [
      "vermarktung_volume",
      "vermarktung_net_revenue",
      "vermarktung_fee",
      "net_revenue_minus_fee"
    ] as const
  },
  marktwert_overview: {
    label: "Marktwertübersicht",
    children: [
      "monatsmarktwert_solar",
      "monatsmarktwert_wind",
      "jahresmarktwert_solar",
      "jahresmarktwert_wind"
    ] as const
  },
  market_premium: {
    label: "Förderung tatsächliche Einspeisung (§51)",
    children: [
      "market_premium_volume",
      "market_premium_revenue",
      "negative_price_volume",
      "negative_price_revenue"
    ] as const
  }
} as const;

export const AUSFALLARBEIT_COLUMN_GROUPS = {
  ausfallarbeit_redispatch_direktvermarkter_group: {
    label: "Redispatch (Abrechnung Direktvermarkter)",
    children: [
      "ausfallarbeit_redispatch_direktvermarkter_group_ausfallarbeit_redispatch",
      "revenue_redispatch",
      "redispatch_entgelt"
    ] as const
  },
  ausfallarbeit_redispatch_netzbetreiber_group: {
    label: "Redispatch (Abrechnung Netzbetreiber)",
    children: [
      "ausfallarbeit_redispatch_netzbetreiber_group_ausfallarbeit_redispatch",
      "aufwandsersatz_redispatch",
      "ausfallarbeit_foerderung_redispatch",
      "revenue_foerderung_redispatch"
    ] as const
  },
  ausfallarbeit_dva_group: {
    label: "Vermarktungserlös Vermarktungs-Abschaltungen",
    children: ["ausfallarbeit_dva", "revenue_dva", "dva_entgelt"] as const
  }
} as const;

export const BASE_COLUMN_KEYS = Object.values(BASE_COLUMN_GROUPS).flatMap(
  (group) => group.children
);

export const AUSFALLARBEIT_COLUMN_KEYS = Object.values(
  AUSFALLARBEIT_COLUMN_GROUPS
).flatMap((group) => group.children);
